import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import './polyfills';

bootstrapApplication(App, appConfig)
  .catch((err: any) => console.error(err));
